import { SET_SERVICE_LIST, SET_ADHOC_SERVICE_LIST, SET_MOBISERV_DETAILS } from '../types';

const INITIAL_STATE = {
    mobiserv: {
        users: [],
        system: {}
    },
    providers: []
}

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case SET_MOBISERV_DETAILS:
            return { 
                ...state, 
                mobiserv: { 
                    users: action.payload.users,
                    system: action.payload.system,
                },
                providers: action.payload.providers
        }
        default:
            return state;
    }
}